import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  ignoreElements,
  map,
  shareReplay,
  startWith,
} from 'rxjs/operators';
import { UploadStatus } from 'src/app/services/uploading/enums/upload-status.enum';

import { UploadingListItem } from '../../../types/uploading-list-item.type';

@Component({
  selector: 'app-lot-add-photo-uploading-list-item',
  templateUrl: './lot-add-photo-uploading-list-item.component.html',
  styleUrls: ['./lot-add-photo-uploading-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoUploadingListItemComponent {
  @Input() isAuctionList = false;
  @Input()
  set uploadingListItem(item: UploadingListItem) {
    this.item = item;
    this.initializeObservables(item);
  }

  @Output() remove = new EventEmitter<UploadingListItem>();
  @Output() openPreview = new EventEmitter<UploadingListItem>();
  @Output() setAsAuctionList = new EventEmitter<UploadingListItem>();

  item: UploadingListItem;
  url$: Observable<string> = EMPTY;
  error$: Observable<Error> = EMPTY;
  status$: Observable<UploadStatus> = EMPTY;
  uploadingProgress$ = of(0);

  isUploaded$ = of(false);
  isUploading$ = of(false);

  private initializeObservables(uploadingListItem: UploadingListItem): void {
    const { url$, status$, uploadingProgress$ } = uploadingListItem;

    this.url$ = url$;
    this.status$ = status$;
    this.uploadingProgress$ = uploadingProgress$;

    this.isUploading$ = this.url$.pipe(
      map(() => false),
      catchError(() => of(false)),
      startWith(true),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.isUploaded$ = this.url$.pipe(
      map(() => true),
      catchError(() => of(false)),
      startWith(false),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.error$ = this.url$.pipe(
      ignoreElements(),
      catchError((error) => of(error)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }
}
